import React from 'react';
import cx from 'classnames';
import { changeBanksFields } from '@utils/banks-selectors';
import BankTransferClaimForm from '@ui-components/bank-transfer-claim/form/index';
import BankTransferClaimSuccess from '@ui-components/bank-transfer-claim/success/index';
import formatAmount from '@utils/amount-formatter';
import random from '@utils/random';
import { createBankTransfer } from '@services/bank-transfer';
import { uploadReceipt } from '@services/receipts';
import { API_ERRORS, BANKS, DLOCALBANKS, CHARS, COUNTRIES, CURRENCY_SYMBOLS } from '@constants';
import { validateBankTransfer, validateBankTransferClaim } from './validators';
import removeAccents from '@utils/remove-accents';
import language from '@language';
import './main.scss';

export default class ClaimBankTransferContainer extends React.Component<any, any> {
  sended: boolean;
    constructor(props) {
        super(props);
        this.sended = false;

        this.state = {
            fields: {
                client_number: '',
                property_name: '',
                holder_name: '',
                document: '',
                email: '',
                invoice_number: '',
                amount: '',
                conditions: false,
                bank_origin: '',
                bank_destination: '',
                voucher: null
            },
            errors: {},
            showBox: false
        };
        
        if (props.country == COUNTRIES.MA){
            this.state.fields.document = CHARS[random(1,26)] + CHARS[random(1,26)] + random(10000,99999);
        }
        
    }

    handleSubmit(fields) {
        this.sended = true;
        const { country } = this.props;
        const errors = validateBankTransferClaim(fields, country);

        /*Form validations*/
        if (Object.keys(errors).length > 0) {
            return this.setState({
                errors: Object.assign({}, this.state.errors, errors)
            });
        }

        const newFields = {
            ...fields,
            email: removeAccents(fields.email)
        }

        /*Send Request*/
        this.setState(
            {
                sending: true
            },
            () => {
                const originBank = BANKS[country].find(bk => bk.id === parseFloat(newFields.bank_origin));
                const destinationBank = DLOCALBANKS[country].find(bk => bk.id === parseFloat(newFields.bank_destination));

                uploadReceipt(newFields.voucher)
                    .then(voucherUpload => {
                        return createBankTransfer({
                            fields: newFields,
                            voucherId: voucherUpload.data.id,
                            country,
                            destinationBankCode: destinationBank.code
                        });
                    })
                    .then(() => {
                        this.setState({
                            success: true,
                            originBank,
                            destinationBank
                        });
                    })
                    .catch(error => {
                        if (error.response && error.response.data) {
                            const errorCode = error.response.data.err?.code;

                            if (errorCode === API_ERRORS.INVALID_INVOICE_NUMBER) {
                                return this.setState(prev => ({
                                    errors: { ...prev.errors, invoice_number: language.form_validation.must_be_ten_digits },
                                    sending: false
                                }));
                            }

                            /*Server validations*/
                            if (errorCode === API_ERRORS.INVALID_DOCUMENT) {
                                return this.setState({
                                    errors: Object.assign({}, this.state.errors, {
                                        document: 'El cuilt/cuil ingresado no es válido'
                                    }),
                                    sending: false
                                });
                            }
                        }
                    });
            }
        );
    }

    handleChange(fields) {
        const { country } = this.props;
        const valid = validateBankTransfer(fields, this.props.country);
        const fieldsWithBanks = changeBanksFields(fields, DLOCALBANKS[country], country);

        const formattedFields = {
            ...fieldsWithBanks,
            amount: formatAmount(fieldsWithBanks.amount)
        };

        this.setState({
            errors: valid,
            fields: formattedFields
        });
    }

    toggleBox() {
        this.setState({
            showBox: !this.state.showBox
        });
    }

    render() {
        const { country } = this.props;
        const { errors, fields, sending, success, errorMessage, showBox } = this.state;
        return (
            <div className={cx('claim-bank-transfer', { closed: !showBox })}>
                {!success && (
                    <BankTransferClaimForm
                        errorMessage={errorMessage}
                        showValidations={this.sended}
                        country={country}
                        sending={sending}
                        banks={BANKS[country]}
                        dlocalBanks={DLOCALBANKS[country]}
                        errors={errors}
                        fields={fields}
                        currency={CURRENCY_SYMBOLS[country]}
                        hideDocument={country==COUNTRIES.MA}
                        onChange={fields => this.handleChange(fields)}
                        onSubmit={fields => this.handleSubmit(fields)}
                    />
                )}

                {success && <BankTransferClaimSuccess fields={fields} />}
            </div>
        );
    }
}
